import {NavigationStart, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {AccessibilityService} from '@commonShared/services/accessibility.service';
import {filter} from 'rxjs/operators';
import {AutoUnsubscribe} from '@commonShared/utils/auto-unsubscribe';
import {Subscription} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
@AutoUnsubscribe()
export class ContrastRoutingInterceptor {

  private _routerSubscription: Subscription;
  private readonly _contrastParamName = 'contrast';

  constructor(private router: Router, private accessibilityService: AccessibilityService) {
    this._routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => this.process(event));
  }

  ngOnDestroy(): void {
  }

  private process(event: NavigationStart): void {
    const urlTree = this.router.parseUrl(event.url);

    if (urlTree.queryParamMap.has(this._contrastParamName)) {
      this.accessibilityService.setContrast(urlTree.queryParamMap.get(this._contrastParamName) === 'high');

      const queryParams = {...urlTree.queryParams};
      delete queryParams[this._contrastParamName];

      const newPath = event.url.split('?', 1)[0];
      this.router.navigate([newPath], {queryParams: queryParams});
    }
  }
}
